import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { IoWarningOutline } from "react-icons/io5";
import { openTemplateConflictsListModal } from "../../redux/templateConflictsListModalSlice";

// Renders on every authenticated screen (mounted from layouts/ContentLayout.jsx) so a
// detected template conflict stays visible regardless of which page the user is on.
// Backed by GET /store/draft/template-conflicts (status_filter=unresolved, fetched once
// on layout mount - see redux/templateConflictsSlice.js). Deliberately generalized - it
// never names which templates conflict, just how many pairs currently do; "Resolve now"
// opens GlobalTemplateConflictsListModal, which does name them.
const GlobalTemplateConflictBanner = () => {
  const dispatch = useDispatch();
  const conflicts = useSelector(state => state.templateConflicts.conflicts);
  const isSidebarOpen = useSelector(state => state.sidebar.isOpen);

  if (!conflicts || conflicts.length === 0) {
    return null;
  }

  const count = conflicts.length;
  const message =
    count === 1
      ? "There is 1 pair of templates with a conflicting description. The AI may pick the wrong reply until you resolve it."
      : `There are ${count} pairs of templates with conflicting descriptions. The AI may pick the wrong reply until you resolve them.`;

  return (
    <div
      className={`flex items-center justify-between gap-4 px-4 sm:px-6 py-3 bg-[#BE1226] text-white font-dmsans transition-all ease-in-out duration-500 ${
        isSidebarOpen ? "lg:ml-[220px] xl:ml-[242px]" : "lg:ml-[80px]"
      }`}
    >
      <div className="flex items-center gap-3">
        <span className="flex-shrink-0 w-8 h-8 rounded-full bg-white/15 flex items-center justify-center">
          <IoWarningOutline className="w-4 h-4 text-white" />
        </span>
        <div>
          <p className="text-sm font-bold tracking-wide uppercase">Conflicting Templates Detected</p>
          <p className="text-xs sm:text-sm text-white/90">{message}</p>
        </div>
      </div>
      <button
        type="button"
        onClick={() => dispatch(openTemplateConflictsListModal())}
        className="flex-shrink-0 bg-white text-[#BE1226] text-sm font-medium px-4 py-2 rounded-md whitespace-nowrap"
      >
        Resolve now
      </button>
    </div>
  );
};

export default GlobalTemplateConflictBanner;
